import React, { useMemo, useState, useRef, useEffect } from 'react'
import * as classes from './News.module.scss'
import cn from 'classnames'
import Container from '../../ui/Container/Container'
import { Link } from 'gatsby'
import InfiniteScroll from 'react-infinite-scroll-component'
import LoaderArticles from '../../ui/LoaderArticles/LoaderArticles'
import { deleteHtmlTag } from '../../../utils/deleteHtmlTag'
import dateFormat from '../../../utils/dateFormat'
import { gsap } from 'gsap/dist/gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function News({ list, lang }) {
    const getItemLink = (href) => {
        if (lang === 'hy') {
            return href
        } else {
            return `/en${href}`
        }
    }

    const items = useMemo(
        () =>
            list.map((item) => {
                const date = dateFormat(item.date, lang)

                return {
                    day: date.day,
                    month: date.monthName,
                    year: date.year,
                    title: item.title,
                    desc: deleteHtmlTag(item.previewText, 'p'),
                    urlCode: item.urlCode
                }
            }),
        []
    )

    const portionRef = useRef(5)

    const [articles, setArticles] = useState(items.slice(0, portionRef.current))

    const fetchMoreData = () => {
        setTimeout(() => {
            setArticles((prev) => [...prev, ...items.slice(portionRef.current, portionRef.current + 5)])
            portionRef.current += 5
        }, 1000)
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            const elems = document.querySelectorAll('.news-item-line')

            elems.forEach((item, index) => {
                gsap.to(item, {
                    duration: 1.4,
                    width: '100%',
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: item,
                        start: 'top 95%'
                    }
                })
            })
        }, 1500)

        return () => clearTimeout(timer)
    }, [articles])

    return (
        <section className={cn(classes.Section, {[classes.LangHY]: lang === 'hy'})}>
            <Container>
                <div className={classes.Items}>
                    <InfiniteScroll
                        dataLength={articles.length}
                        next={fetchMoreData}
                        hasMore={articles.length < items.length}
                        loader={<LoaderArticles />}
                        scrollableTarget='scrollableDiv'
                    >
                        {articles.map((item, index) => {
                            return (
                                <div className={classes.Item} key={index}>
                                    <div className={classes.Line + ' news-item-line '} />

                                    <div className={classes.ItemDate}>
                                        <span className={classes.ItemNumber}>{item.day}</span>
                                        <p className={classes.ItemMonth}>
                                            {item.month} {item.year}
                                        </p>
                                    </div>

                                    <div className={classes.ItemContent}>
                                        <Link to={getItemLink(`/news/${item.urlCode}/`)}>
                                            <h2 className={classes.ItemTitle} dangerouslySetInnerHTML={{ __html: item.title }} />
                                        </Link>

                                        <p className={classes.ItemDesc} dangerouslySetInnerHTML={{ __html: item.desc }} />
                                    </div>
                                </div>
                            )
                        })}
                    </InfiniteScroll>
                </div>
            </Container>
        </section>
    )
}

export default News
